import React, { FC } from "react";
import { Typography, Box } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { t } from "i18next";

import {
  StyledFormBasics,
  StyledProfileContent,
  StyledFieldBox,
  StyledIconButton,
} from "./FormBasics.styled";

import { useGetCsobFormsMetadata } from "@api";
import { useMultistepFormStore } from "@components/common/MultistepForm";
import { useUserStore } from "@store/user";

interface FormBasicsCsobProps {
  onEdit: () => void;
}

const FormBasicsCsob: FC<FormBasicsCsobProps> = ({ onEdit }) => {
  const {
    formSettings: {
      formBasics: { id },
    },
  } = useMultistepFormStore();
  const { user } = useUserStore();
  const { availableFormsMetadata } = useGetCsobFormsMetadata(user);
  const formMetaData = availableFormsMetadata?.find((form) => form.formId === id);

  if (formMetaData?.questionnaireType === "client") return;

  return (
    <StyledFormBasics>
      <StyledProfileContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <StyledFieldBox>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ minWidth: "55px" }}
            >
              {t("csobFormMetadata.name")}
              {": "}
            </Typography>
            <Typography variant="body2" sx={{ flex: 1 }}>
              {formMetaData?.name}
            </Typography>
          </StyledFieldBox>
          <StyledIconButton onClick={onEdit} size="small">
            <Edit />
          </StyledIconButton>
        </Box>
        <StyledFieldBox>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ minWidth: "55px" }}
          >
            {t("csobFormMetadata.type")}
            {": "}
          </Typography>
          <Typography variant="body2" sx={{ flex: 1 }}>
            {t(`csobFormMetadata.formType.${formMetaData?.questionnaireType}`)}
          </Typography>
        </StyledFieldBox>
      </StyledProfileContent>
    </StyledFormBasics>
  );
};

export default FormBasicsCsob;
